export default "__VITE_ASSET__DwzhZeoT__"